import { connect } from 'react-redux'
import { IStoreState, IVehicleFilters } from '../../types'

import ServicesSearch from '../../components/vehicles/VehicleSearch'
import * as actions from '../../state/actions/vehicles/'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    type: ownProps.type
  }
}

export function mapDispatchToProps(dispatch: any): any {
  let timeout: any

  return {
    onInputChange: (params: IVehicleFilters) => {
      const requestDelay = 500
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        // if (query.length === 0) {
        dispatch(actions.getVehicles({ ...params, useJSONResp: true }))
        // }
        // dispatch(search(orgId, query, type))
      }, requestDelay)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesSearch)



// WEBPACK FOOTER //
// ./src/containers/vehicles/VechicleSearch.ts